import { Component, Input } from '@angular/core'

@Component({
    selector: 'app-notification-tooltip',
    templateUrl: './notification-tooltip.component.html',
    styleUrl: './notification-tooltip.component.scss',
    standalone: false
})
export class NotificationTooltipComponent {
  @Input() items: { name: string; title: string; url: string; status?: number }[] = []
}
